import { render, staticRenderFns } from "./MediaShare.vue?vue&type=template&id=3f350767&scoped=true&"
import script from "./MediaShare.vue?vue&type=script&lang=js&"
export * from "./MediaShare.vue?vue&type=script&lang=js&"
import style0 from "./MediaShare.vue?vue&type=style&index=0&id=3f350767&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f350767",
  null
  
)

export default component.exports